module.exports = __webpack_public_path__ + "img/octave.97d164b5.jpg";